import { Alert } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'

const DuplicateWarning = ({ duplicates }) => {
  if (!duplicates || duplicates.length === 0) return null

  return (
    <WarningContainer>
      <Alert
        message='Duplicate Products Detected'
        description={
          <div>
            <p>
              The following products appear multiple times in your basket.
              Please review and remove duplicates before confirming your order.
            </p>
            <DuplicateList>
              {duplicates.map((dup, index) => (
                <DuplicateItem key={index}>
                  <strong>{dup.productTitle}</strong> ({dup.supplierTitle}) -{' '}
                  {dup.duplicateOrders.length} duplicate
                  {dup.duplicateOrders.length > 1 ? 's' : ''} found
                </DuplicateItem>
              ))}
            </DuplicateList>
          </div>
        }
        type='warning'
        showIcon
        style={{ marginBottom: '20px' }}
      />
    </WarningContainer>
  )
}

const WarningContainer = styled.div`
  margin-bottom: 20px;
`

const DuplicateList = styled.ul`
  margin-top: 10px;
  padding-left: 20px;
`

const DuplicateItem = styled.li`
  margin-bottom: 5px;
`

export default DuplicateWarning
